// src/pages/Usage.js
import React from 'react';

function Usage() {
  return (
    <div>
      <h2>Usage</h2>
      <p>Information on how to use the software effectively.</p>
    </div>
  );
}

export default Usage;
